/**
 * Neyra event categories — 2-level taxonomy.
 * Used by Create Event category picker.
 */
export const EVENT_CATEGORIES = [
    {
        id: "social",
        label: "Social & Hangouts",
        subs: [
            "Casual Hangouts",
            "Coffee Meetups",
            "Brunch / Dinner",
            "Game Nights",
            "Networking Meetups",
        ],
    },
    {
        id: "music",
        label: "Music & Entertainment",
        subs: [
            "Live Concerts",
            "DJ Parties",
            "Music Festivals",
            "Open Mic",
            "Karaoke Nights",
            "Album Launch",
        ],
    },
    {
        id: "nightlife",
        label: "Nightlife & Parties",
        subs: [
            "Club Parties",
            "Pool Parties",
            "House Parties",
            "Beach Parties",
            "Themed Parties",
            "After Parties",
        ],
    },
    {
        id: "food",
        label: "Food & Drink",
        subs: [
            "Food Festivals",
            "Wine Tasting",
            "Cocktail Nights",
            "Restaurant Pop-ups",
            "Street Food Events",
        ],
    },
    {
        id: "business",
        label: "Business & Networking",
        subs: [
            "Business Meetups",
            "Startup Events",
            "Conferences",
            "Workshops",
            "Masterclasses",
        ],
    },
    {
        id: "education",
        label: "Education & Learning",
        subs: [
            "Tech Bootcamps",
            "Coding Classes",
            "Skill Workshops",
            "Career Talks",
            "Language Classes",
        ],
    },
    {
        id: "fitness",
        label: "Fitness & Wellness",
        subs: [
            "Gym Classes",
            "Yoga Sessions",
            "Outdoor Workouts",
            "Wellness Retreats",
            "Meditation",
        ],
    },
    {
        id: "arts",
        label: "Arts & Culture",
        subs: [
            "Art Exhibitions",
            "Museum Tours",
            "Cultural Festivals",
            "Theatre & Drama",
            "Poetry / Spoken Word",
        ],
    },
    {
        id: "outdoor",
        label: "Outdoor & Adventure",
        subs: [
            "Hiking",
            "Camping",
            "Picnics",
            "City Tours",
            "Boat Cruises",
            "Road Trips",
        ],
    },
    {
        id: "family",
        label: "Family & Kids",
        subs: [
            "Kids Playdates",
            "Family Fun Days",
            "School Events",
            "Birthday Parties",
            "Kids Workshops",
        ],
    },
    {
        id: "religious",
        label: "Religious & Community",
        subs: [
            "Church Programs",
            "Mosque Events",
            "Community Gatherings",
            "Charity Events",
        ],
    },
    {
        id: "virtual",
        label: "Virtual Events",
        subs: [
            "Webinars",
            "Virtual Hangouts",
            "Live Streams",
            "Online Classes",
        ],
    },
    {
        id: "other",
        label: "Other",
        subs: [],
    },
];

export const findEventCategory = (categoryLabel) =>
    EVENT_CATEGORIES.find((c) => c.label === categoryLabel) || null;
